import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';

import {isTranslate} from 'shared/lib/lang';
import Logo from 'shared/ui/icons/General/Logo';
import LogoEn from 'shared/ui/icons/General/LogoEn';
import LogoOwner from 'shared/ui/icons/General/LogoOwner';

import styles from './ErrorPage.module.scss';

interface IErrorPageProps {
    code: number;
    description: React.ReactNode;
    linkTo: string;
    linkLabel: string;
    className?: string;
}

const ErrorPage: React.FC<IErrorPageProps> = ({code, description, linkTo, linkLabel, className}) => (
    <div className={cn(styles.container, className)}>
        <div className={styles.logo}>
            <a href={AppUrls.MAIN_OVERSEER} target="_blank" rel="noopener noreferrer">
                {isTranslate() ? <LogoEn/> : <Logo/>}
            </a>
        </div>
        <div className={styles.content}>
            <h1 className={styles.title}>{code}</h1>
            <p className={styles.description}>{description}</p>
            <Link to={linkTo} className={styles.link_home}>
                {linkLabel}
            </Link>
        </div>
        {
            !isTranslate() &&
            <a className={styles.owner} href={AppUrls.MAIN_BROTHER} target="_blank" rel="noopener noreferrer">
                <LogoOwner/>
                <span className={styles.owner_name}>brotherhood.software</span>
            </a>
        }
    </div>
);

export default ErrorPage;
